import { render, staticRenderFns } from "./ActiveTicket.vue?vue&type=template&id=3838f78c&scoped=true&"
import script from "./ActiveTicket.vue?vue&type=script&lang=js&"
export * from "./ActiveTicket.vue?vue&type=script&lang=js&"
import style0 from "./ActiveTicket.vue?vue&type=style&index=0&id=3838f78c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3838f78c",
  null
  
)

export default component.exports